import type { PmeLifeRow } from '../proposal.mock';

/**
 * Situação de uma vida na tabela do Resumo da proposta PME — o que a bolinha da
 * coluna STATUS representa.
 */
export type PmeLifeStatus = 'complete' | 'incomplete' | 'inactive';

/** Verifica nome e CPF para o bloqueio da assinatura digital. */
export function isPmeLifeIncomplete(
  life: Pick<PmeLifeRow, 'name' | 'cpf'>
): boolean {
  return !life.name?.trim() || !life.cpf?.trim();
}

/** Situação exibida na coluna STATUS. */
export function resolvePmeLifeStatus(life: PmeLifeRow): PmeLifeStatus {
  if (life.status === 'inactive') return 'inactive';
  const complete = [
    life.birthDate,
    life.cpf,
    life.gender,
    life.name,
    life.insurableGroup,
  ].every(value => !!value?.trim() && value.trim() !== '—');
  return complete ? 'complete' : 'incomplete';
}

/** Cor da bolinha por situação. */
export const PME_LIFE_STATUS_DOT_CLASS: Record<PmeLifeStatus, string> = {
  complete: 'bg-alba-success-green-500',
  incomplete: 'bg-yellow-500',
  inactive: 'bg-alba-gray-400',
};

/** Texto do `title` da bolinha — a cor sozinha não explica o que fazer. */
export const PME_LIFE_STATUS_LABEL: Record<PmeLifeStatus, string> = {
  complete: 'Dados completos',
  incomplete: 'Informações pendentes',
  inactive: 'Afastado',
};
